"use client";

import { create } from "zustand";
import { api } from "@/lib/api";
import { CustomerAuthResponse } from "@/types";
import * as Sentry from "@sentry/nextjs";

interface AuthCustomer {
  customerId: string;
  email: string;
  fullName: string;
}

interface AuthStore {
  customer: AuthCustomer | null;
  isAuthenticated: boolean;
  isReady: boolean;
  initialize: () => Promise<void>;
  login: (response: CustomerAuthResponse) => void;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthStore>((set) => ({
  customer: null,
  isAuthenticated: false,
  isReady: false,

  initialize: async () => {
    try {
      const { data } = await api.get<{ id: string; email: string; fullName: string }>("/api/account/me");
      Sentry.setUser({ id: data.id });
      set({
        customer: {
          customerId: data.id,
          email: data.email,
          fullName: data.fullName,
        },
        isAuthenticated: true,
        isReady: true,
      });
    } catch {
      set((state) => state.isAuthenticated
        ? { ...state, isReady: true }
        : { customer: null, isAuthenticated: false, isReady: true });
    }
  },

  login: (response: CustomerAuthResponse) => {
    Sentry.setUser({ id: response.customerId });
    set({
      customer: {
        customerId: response.customerId,
        email: response.email,
        fullName: response.fullName,
      },
      isAuthenticated: true,
      isReady: true,
    });
  },

  logout: async () => {
    try {
      await api.post("/api/account/logout");
    } catch {
      // Oturum zaten düşmüş olabilir
    }

    Sentry.setUser(null);
    set({ customer: null, isAuthenticated: false, isReady: true });
  },
}));
